import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fg } from '@atlaskit/platform-feature-flags';
import { V003_SCHEMA_KEY } from '../../../constants';
import { fetchConsentPreferences } from '../../../services/consent-hub-service';
import { checkTokenVersionValidity } from '../transformer';
export var getValidConsentData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fallbackConsentToken) {
    var consentData, consentToken, consentTimestamp, consentHubInaccessible, _checkTokenVersionVal, isValid, version, consents, serviceBits;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchConsentPreferences();
        case 2:
          consentData = _context.sent;
          consentToken = consentData.consentToken, consentTimestamp = consentData.consentTimestamp, consentHubInaccessible = consentData.consentHubInaccessible;
          _checkTokenVersionVal = checkTokenVersionValidity(consentToken), isValid = _checkTokenVersionVal.isValid;
          if (isValid && consentHubInaccessible) {
            if (fallbackConsentToken) {
              // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
              // any previously set consents in the interim if we have them.
              consentToken = fallbackConsentToken;
            } else {
              if (fg('platform_moonjelly_bsc_fallback_token_audit')) {
                version = V003_SCHEMA_KEY;
                consents = consentToken.slice(3, 7); // V003 BSC bits set to reflect default consent token status, authenticated user status,
                // and unavailable consentHub records status)
                serviceBits = '111'; // Temporary: Sets a default token with V003 properties
                // when ConsentHub is inaccessible and there is not fallback token. This
                // will ensure the banner isn't shown when ConsentHub is down.
                consentToken = "".concat(version).concat(consents).concat(serviceBits);
              } else {
                // Temporary: Sets the default token to have true consentedUnderXXXX bits
                // when ConsentHub is inaccessible and there is not fallback token. This
                // will ensure the banner isn't shown when ConsentHub is down.
                consentToken = "".concat(consentToken.slice(0, 8), "1111");
              }
            }
          }
          return _context.abrupt("return", isValid ? {
            consentToken: consentToken,
            consentTimestamp: consentTimestamp
          } : undefined);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getValidConsentData(_x) {
    return _ref.apply(this, arguments);
  };
}();